import React from "react";
import FormViewer from "../components/FormViewer";
import LoaderButton from "../components/LoaderButton";
import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
import { checkPermission, checkTranslation, translate } from "../utils/useful";
// import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import moment from "jalali-moment";

class ItemModal extends React.Component {

    submitForm = () => {
        if (this.props.submitForm) {
            let data = this.form.getForm()
            if (data) {
                this.props.submitForm({ ...data })
            }
        } else {
            this.postValue()
        }
    }
    hideModal = () => {
        this.modal.hideModal()
    }

    state = {
        countries: [],
        actions: {
            submit: { key: "submit", label: "{{lang}}Send", bgColor: ' rgb(24, 77, 148)', color: '#fff', function: this.submitForm, loader: "isPostingData" },
            cancel: { key: "cancel", label: "{{lang}}Cancel", bgColor: '#d4d4d4', color: '#222', function: this.hideModal },
        }
    }
    componentDidMount() {

        this.init()
    }

    componentDidUpdate(prevProps) {
        // console.log('this.props', this.props)
        if (this.props.initData != prevProps.initData && (this.props.initData?._id)) {

            this.init(true)

        }
        else if (JSON.stringify(this.props.initData) != JSON.stringify(prevProps.initData) && (!this.props.initData?._id)) {

            this.init()

        }
        else if (prevProps.headers != this.props.headers) {

            this.init()
        }
    }

    init(isEdit) {
        let headers = []
        if (this.props.headers && isEdit) {
            headers = JSON.parse(JSON.stringify(this.props.headers))
            headers.map((element, index) => {
                if (element.key == 'password') {
                    headers[index].information.required = false
                }
                if (element.key == 'parentItem') {
                    console.log('eleee', element)
                }
            })
        }
        else if (this.props.headers && !isEdit) {
            headers = JSON.parse(JSON.stringify(this.props.headers))
            // console.log('object')
            headers.map((element, index) => {
                if (element.key == 'password') {
                    headers[index].information.required = true
                }
            })
        }
        this.setState({ headers: headers, activePage: null })
    }







    postValue = () => {
        // console.log("postValue")
        if (this.form) {
            console.log('s', this.form)
            let data = this.form.getForm()
            this.setState({ errors: null })
            let page = this.props.page

            // console.log('page is', page)
            if (data) {
                let isEditing = data._id ? true : false
                if (!isEditing && data.id) {
                    isEditing = true
                }
                // console.log('data is', data)
                // console.log('isEditing', isEditing)
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                data.page = this.props.page?.page ? this.props.page?.page : this.props.page?.key
                this.setState({ isPostingData: true })

                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }

                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {

                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }

                data.frame = page.key

                // console.log('addddddddd', address,data)

                // return
                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    console.log(fetchError)
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    this.modal.hideModal()
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}Sent Succesfully', description: '{{lang}}Send Record Succesfully' })
                    if (!isEditing && this.props.itemAdded) {
                        this.props.itemAdded(fetchResult.info, this.props.modalIndex)
                    }

                    if (isEditing && this.props.itemEdited) {
                        // console.log("itemEdited")
                        // console.log(data)
                        if (fetchResult.info) {
                            this.props.itemEdited(fetchResult.info, data._id, this.props.modalIndex)
                        } else {
                            this.props.itemEdited(data, data._id, this.props.modalIndex)
                        }
                    }
                })
            }
        }
    }

    changePage = (index, prop) => {
        this.setState({ activePage: index, hideModal: true }, () => {
            if (index == null) {
                this.setState({ hideModal: false, headers: this.props.headers })
            } else {
                this.setState({ hideModal: false, headers: this.props.page?.pages[index].headers })

            }
        })
    }

    itemAdded = () => { }

    itemEdited = () => { }


    render() {
        // console.log('tttttttttttttttttttt', ((this.props.initData?._id && (checkPermission(this.props.variables?.permissionRoot + '.edit') || checkPermission(this.props.variables?.permissionParentRoot + '.edit')))))
        return (

            <Modal ref={el => this.modal = el} maxWidth={800}>
                <div className="pb-5 w-100 h-100">
                    <div className="w-100 h-100 sc-1" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
                        <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', background: 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>
                            <div>
                                {!this.props.page?.hideOption ? (
                                    <p style={{ color: "#fff" }}>{(this.props.title ?? (this.props?.initData?._id ? translate('Edit') : translate('Add')))}</p>
                                ) : (
                                    <p style={{ color: "#fff" }}>{translate('View')}</p>
                                )}
                            </div>
                            <div className="cursor-pointer" onClick={() => this.modal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img className="invert" style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                            </div>

                        </div>
                        {this.props.page?.pages && (
                            <div className="w-100 flexc mb-2">

                                <div className="ml-0 text-center" onClick={() => { this.changePage(null) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.activePage == null ? '#F87C56' : '#F87C56b7fb7f', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                    <p>{translate('Details')}</p>
                                </div>

                                {this.props.page.pages.map((prop, index) => {
                                    return (
                                        <div className="ml-0 text-center" onClick={() => { this.changePage(index, prop) }} style={{ flex: 1, fontSize: 16, cursor: 'pointer', borderLeft: '1px solid #89a', transition: 'all 0.3s', backgroundColor: this.state.activePage == index ? (prop.tabColor ?? '#F87C56') : '#F87C56b7fb7f', borderRadius: '0px 0px 0px 0px', color: '#fff', padding: '10px 20px' }}>
                                            <p>{checkTranslation(prop.title)}</p>
                                        </div>)
                                })}

                            </div>
                        )}

                        {!this.state.hideForm && (
                            <div className="py-3 px-4">
                                {/* {console.log('editthis.state.headers',this.state.headers)} */}
                                {/* {console.log('editthis.props.initData',this.props.initData)} */}
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} isEditing={this.props?.initData?._id ? true : false} initData={this.props.initData} errors={this.state.errors} inputClass={'modern-input'} variables={this.props.variables} openRefModal={this.props.openRefModal} functionsHandler={this.props.functionsHandler} />
                            </div>
                        )}


                        <div className="flexc px-3 pb-3">

                            {!this.props.page?.hideOption && Object.values(this.state.actions).map((prop, index) => {
                                if (prop.key != 'submit' || (!this.props.initData?._id && (checkPermission(this.props.variables?.permissionRoot + '.create') || checkPermission(this.props.variables?.permissionParentRoot + '.create'))) || (this.props.initData?._id && (checkPermission(this.props.variables?.permissionRoot + '.edit') || checkPermission(this.props.variables?.permissionParentRoot + '.edit')))) {
                                    return (
                                        <div key={index} className=" mx-1">
                                            <LoaderButton
                                                onClick={prop.function}
                                                isLoading={this.props[prop.loader] ?? this.state[prop.loader]}
                                                text={checkTranslation(prop.label)}
                                                type={"Oval"}
                                                className="text-bold text-small text-uppercase w-100"
                                                buttonStyle={{ outline: 'none', width: 130, backgroundColor: prop.bgColor, cursor: 'pointer', padding: '8px 15px', borderRadius: 50, textTransform: 'uppercase', fontSize: 15, fontWeight: '400', color: prop.color, border: 'none' }}
                                                width={40}
                                                height={40}
                                                color={prop.color}
                                            />
                                        </div>
                                    )
                                }

                            })}
                        </div>
                    </div>
                </div>
            </Modal>
        );

    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(ItemModal);
